export const types = {
    SET_LIST_CODE_COUNTRY: '[CODE COUNTRY] SET LIST CODE COUNTRY'
}